import { render, staticRenderFns } from "./NoHeadLayout.vue?vue&type=template&id=211dffce"
import script from "./NoHeadLayout.vue?vue&type=script&lang=js"
export * from "./NoHeadLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports